/**
 * This file only loads polyfills for the users who use a browser that don't support the features.
 * For them, the loading time will increase a little but, for the vast majority the users the load time will be reduced.
 */

// always polyfills symbol, without it our app doesn't render in 4.4.4
import 'core-js/es/symbol';

// Polyfill for `:focus-visible` - https://github.com/wicg/focus-visible
import 'focus-visible';

import { _detectIE } from 'utils/UserAgent';

if (!window.location.origin) {
  // @ts-ignore
  window.location.origin = `${window.location.protocol}//${window.location.hostname}${
    window.location.port ? `:${window.location.port}` : ''
  }`;
}

export async function importPolyfills(): Promise<any[]> {
  const promises: Array<Promise<any>> = [];

  const ieVersion: number | false = _detectIE();

  // Support IE 11
  if (ieVersion && ieVersion <= 11) {
    promises.push(
      import(
        /* webpackChunkName: "ie11-polyfill" */
        'polyfills/ie11'
      ),
    );
    return Promise.all(promises);
  }

  if (typeof window.IntersectionObserver === 'undefined') {
    promises.push(
      import(
        /* webpackChunkName: "intersection-observer" */
        'intersection-observer'
      ),
    );
  }

  if (typeof window.fetch === 'undefined') {
    promises.push(
      import(
        /* webpackChunkName: "whatwg-fetch" */
        'whatwg-fetch'
      ),
    );
  }

  if (typeof Set === 'undefined') {
    promises.push(
      import(
        /* webpackChunkName: "set-polyfill" */
        'polyfills/set'
      ),
    );
  }

  if (typeof Map === 'undefined') {
    promises.push(
      import(
        /* webpackChunkName: "map-polyfill" */
        'polyfills/map'
      ),
    );
  }

  if (typeof Array.prototype.includes === 'undefined') {
    promises.push(
      import(
        /* webpackChunkName: "array-polyfill" */
        'polyfills/array'
      ),
    );
  }

  if (
    typeof String.prototype.startsWith === 'undefined' ||
    typeof String.prototype.includes === 'undefined'
  ) {
    promises.push(
      import(
        /* webpackChunkName: "string-polyfill" */
        'polyfills/string'
      ),
    );
  }

  if (typeof Object.values === 'undefined') {
    promises.push(
      import(
        /* webpackChunkName: "object-polyfill" */
        'polyfills/object'
      ),
    );
  }

  return Promise.all(promises);
}
